<mat-dialog-content>
	@if (!createNew.value) {
	<h1
		class="pl-4 pt-0"
		matDialogTitle
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<div>{{ 'dashboard.dashboardMenu' | translate }}</div>
			<div class="flex-auto"></div>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</h1>
	<mat-dialog-content class="-mx-24px pt-0">
		<div class="flex flex-col h-full">
			<div class="flex flex-row items-center justify-start gap-2">
				<mat-form-field
					appearance="fill"
					class="flex-grow"
				>
					<mat-label>{{ 'dashboard.dashboardName' | translate }}</mat-label>
					<input
						[formControl]="this.nameField"
						matInput
					>
				</mat-form-field>
			</div>

			<mat-list class="h-full pt-0 mat-bd-5 flex flex-col gap-y-4 rounded-lg px-0">
				@if (pinnedDashboard$ | async; as filteredControls) { @if (nameField.invalid &&
				!filteredControls.length) {
				<mat-list-item>
					<span class="text-muted-foreground">{{ 'dashboard.noDashboards' | translate }}</span>
				</mat-list-item>
				} @else {
				<div class="pl-5"><span>{{ 'dashboard.favDashboards' | translate }}</span></div>
				<div
					(cdkDropListDropped)="drop($event)"
					[cdkDropListData]="filteredControls"
					cdkDropList
					class="flex flex-col max-h-[500px] overflow-y-auto"
				>
					<mat-list-item
						[cdkDragDisabled]="control.value.editing"
						[formGroup]="control"
						*ngFor="let control of filteredControls; trackBy: trackId"
						cdkDrag
						class="cursor-pointer w-full h-12"
					>
						<div class="flex items-center gap-x-2 w-full">
							<!-- bookmark icon -->
							<ng-container
								*ngIf="control.value.editingColor; else readonlyColor"
								class="pr-1"
							>
								<mat-icon
									(colorPickerClose)="onCloseColorPicker(control, nameElement, $event)"
									[(colorPicker)]="control.get('color').value"
									[cpToggle]="control.value.editingColor"
									[style.color]="control.get('color').value"
									class="flex-none cursor-pointer"
									cpPosition="bottom"
								>
									bookmark
								</mat-icon>
							</ng-container>

							<ng-template #readonlyColor>
								<mat-icon
									[style.color]="control.value.color"
									class="flex-none"
								>
									bookmark
								</mat-icon>
							</ng-template>
							<!-- displayname -->
							@if (control.value.editing) {
							<div class="rounded-lg flex-grow border border-gray-200">
								<input
									(blur)="updateName(control)"
									(keyup.enter)="updateName(control)"
									#nameElement="nativeElement"
									class="mat-truncate leading-10 h-10 px-3 pb-4 pl-1 rounded-lg flex-grow"
									elementRef
									formControlName="displayName"
									matInput
									type="text"
								>
							</div>
							} @else {
							<div class="mat-truncate leading-10 h-10 px-3 rounded flex-grow">
								<span>{{ control.value.displayName }}</span>
							</div>
							}

							<!-- fav icon -->
							<button
								(click)="addAndRemovePinned(control.value.id)"
								[matTooltip]="'dashboard.unPin' | translate"
								class="flex items-center"
							>
								<mat-icon
									[color]="control.value.pinned ? 'accent' : null"
									class="flex-none"
								>
									star
								</mat-icon>
							</button>

							<!-- options -->
							<button
								(click)="$event.stopPropagation()"
								[matMenuTriggerData]="{ $implicit: control }"
								[matMenuTriggerFor]="settingsMenu"
								class="px-0 flex-none"
								mat-icon-button
							>
								<mat-icon>more_vert</mat-icon>
							</button>
						</div>

						<!-- Menu -->
						<mat-menu
							[overlapTrigger]="true"
							#settingsMenu="matMenu"
							class="py-0"
						>
							<div class="flex flex-col space-y-1">
								<button
									(click)="selectItem(control)"
									mat-menu-item
								>
									<mat-icon>check</mat-icon>
									{{ 'utils.apply' | translate }}
								</button>
								<button
									(click)="enablColoreEdit(control, nameElement)"
									mat-menu-item
								>
									<mat-icon>edit</mat-icon>
									{{ 'utils.edit' | translate }}
								</button>
								<button
									(click)="deleteDashboard(control, confirmDeleteDialog)"
									mat-menu-item
								>
									<mat-icon>delete</mat-icon>
									{{ 'utils.delete' | translate }}
								</button>
							</div>
						</mat-menu>
					</mat-list-item>
				</div>
				}
				<br>
				<br>
				@if (filteredControlsNotPinned$ | async; as notPinned) { @if (notPinned.length) {
				<div class="pl-5"><span>{{ 'dashboard.moreDashboards' | translate }}</span></div>
				<cdk-virtual-scroll-viewport
					[itemSize]="48"
					class="h-96"
				>
					<div class="h-96">
						<mat-list-item
							[formGroup]="control"
							*cdkVirtualFor="let control of notPinned; trackBy: trackId"
							class="cursor-pointer w-full h-12"
						>
							<div class="flex items-center gap-x-2 w-full">
								<!-- bookmark icon -->
								<ng-container
									*ngIf="control.value.editingColor; else readonlyColor"
									class="pr-1"
								>
									<mat-icon
										(colorPickerClose)="onCloseColorPicker(control, nameElement, $event)"
										[(colorPicker)]="control.get('color').value"
										[cpToggle]="control.value.editingColor"
										[style.color]="control.get('color').value"
										class="flex-none cursor-pointer"
										cpPosition="bottom"
									>
										bookmark
									</mat-icon>
								</ng-container>

								<ng-template #readonlyColor>
									<mat-icon
										[style.color]="control.value.color"
										class="flex-none"
									>
										bookmark
									</mat-icon>
								</ng-template>
								<!-- displayname -->
								@if (control.value.editing) {
								<div class="rounded-lg flex-grow border border-gray-200">
									<input
										(blur)="updateName(control)"
										(keyup.enter)="updateName(control)"
										#nameElement="nativeElement"
										class="mat-truncate leading-10 h-10 px-3 pb-4 pl-1 rounded-lg flex-grow"
										elementRef
										formControlName="displayName"
										matInput
										type="text"
									>
								</div>
								} @else {
								<div class="mat-truncate leading-10 h-10 px-3 rounded flex-grow">
									<span>{{ control.value.displayName }}</span>
								</div>
								}<!-- fav icon-->
								<button
									(click)="addAndRemovePinned(control.value.id)"
									class="flex items-center"
									matTooltip=" {{ 'dashboard.pin' | translate }}"
								>
									<mat-icon
										[ngStyle]="control.value.pinned ? { color: 'yellow' } : {}"
										class="flex-none"
									>
										star
									</mat-icon>
								</button>
								<!-- options button -->
								<button
									(click)="$event.stopPropagation()"
									[matMenuTriggerData]="{ $implicit: control }"
									[matMenuTriggerFor]="settingsMenu"
									class="px-0 flex-none"
									mat-icon-button
								>
									<mat-icon>more_vert</mat-icon>
								</button>
							</div>
							<!-- Menu content -->
							<mat-menu
								[overlapTrigger]="true"
								#settingsMenu="matMenu"
								class="py-0"
							>
								<div class="flex flex-col space-y-1">
									<button
										(click)="selectItem(control)"
										*ngIf="!control.value.pinned"
										mat-menu-item
										type="button"
									>
										<mat-icon>check</mat-icon>
										{{ 'utils.apply' | translate }}
									</button>
									<button
										(click)="enablColoreEdit(control, nameElement)"
										mat-menu-item
										type="button"
									>
										<mat-icon>edit</mat-icon>
										{{ 'utils.edit' | translate }}
									</button>
									<button
										(click)="deleteDashboard(control, confirmDeleteDialog)"
										mat-menu-item
										type="button"
									>
										<mat-icon>delete</mat-icon>
										{{ 'utils.delete' | translate }}
									</button>
								</div>
							</mat-menu>
						</mat-list-item>
					</div>
				</cdk-virtual-scroll-viewport>
				} } }
			</mat-list>
		</div>
	</mat-dialog-content>
	}
	<ng-container *ngIf="createNew.value$ | async">
		<div class="pt-0 mat-bd-5 mb-8 flex flex-col gap-y-4 rounded-lg px-0 pb-4">
			<!--  header-->
			<h1
				class="pt-0"
				matDialogTitle
			>
				<div class="flex flex-row items-center justify-start gap-2">
					<div>{{ 'reports.createNew' | translate }}</div>
					<div class="flex-auto"></div>
					<button
						(click)="this.createNew.next(false)"
						mat-icon-button
					>
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</h1>
			<div class="flex flex-auto flex-row items-center justify-start">
				<mat-icon
					(colorPickerChange)="this.color.setValue($event)"
					[colorPicker]="color.value"
					[cpAlphaChannel]="'disabled'"
					[cpCmykEnabled]="false"
					[cpOutputFormat]="'hex'"
					[ngStyle]="{ color: color.value }"
					class="color-picker-icon"
					matPrefix
					style="width: 36px; height: 36px; font-size: 36px"
				>
					bookmark
				</mat-icon>
				<mat-form-field
					appearance="fill"
					class="flex-auto"
				>
					<mat-label>{{ 'Name' | translate }}</mat-label>
					<input
						[formControl]="this.name"
						matInput
						type="text"
					>
					<mat-error *ngIf="name.hasError('dupelicateName')">
						<span>{{ 'errors.duplicatenames' | translate }}</span>
					</mat-error>
				</mat-form-field>
			</div>
			<button
				(click)="submit()"
				[disabled]="this.name.invalid"
				class="mat-action-filled"
				color="primary"
				mat-flat-button
			>
				<div>{{ 'reports.createNew' | translate }}</div>
			</button>
		</div>
	</ng-container>
</mat-dialog-content>

<ng-template
	#confirmDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'dashboard.confirmDelete' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.delete' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
